import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import TreemapModule from 'highcharts/modules/treemap';

TreemapModule(Highcharts);

const TreeMap = ({treeData, extraMargin, onClick}) => {

  const onClickCatgory = (event) => {
    onClick(event.point.name);
  }

  const options = {
    chart: {
      marginLeft: extraMargin,
      marginRight: extraMargin,
    },
    series: [
      {
        name: "",
        type: "treemap",
        layoutAlgorithm: "squarified",
        allowDrillToNode: true,
        animationLimit: 1000,
        dataLabels: {
          enabled: false,
          color: "#ffffff",
          useHTML: true,
          style: {
            fontSize: "13px",
            fontWeight: 500,
            fontFamily: "Verdana, sans-serif",
          },
        },
        cursor: "pointer",
        events: {
          click: onClickCatgory,
        },
        levels: [
          {
            level: 1,
            dataLabels: {
              enabled: true,
            },
            borderWidth: 3,
            levelIsConstant: false,
          },
        ],
        accessibility: {
          exposeAsGroupOnly: true,
        },
        data: treeData,
        color: "#4096ff",
      },
    ],
    title: {
      text: "Categories",
      align: "left",
      style:{
        fontSize: "13px",
        fontFamily: "Verdana, sans-serif",
      }
    },
    tooltip:{
      backgroundColor: "#ffffff",
      valueSuffix: "%",
      useHTML: true,
      outside: true
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default TreeMap;
